module.exports = __webpack_public_path__ + "img/shop.6b598217.png";